import { Link } from 'react-router-dom';

import { useLanguage } from '../context/LanguageContext';
import { site } from '../data/site';

function ContactPage() {
  const { language, t } = useLanguage();
  const copy = language === 'ru'
    ? {
        title: 'Поможем спланировать проживание',
        lead: 'Проверьте свободные даты онлайн, выберите апартамент и дополнительные услуги для проживания',
        transferTitle: 'Трансфер по запросу',
        transferText: 'Организуем встречу в аэропорту и обратный трансфер по предварительной договорённости. Услуга оплачивается отдельно.',
        location: 'Адрес и парковка',
        locationText: 'Резиденция находится в Святом‑Стефане. Для гостей предусмотрена частная парковка в здании.',
        map: 'Открыть карту',
      }
    : {
        title: 'Let us help shape your stay',
        lead: 'Check live availability online, choose an apartment and add any services needed for your stay',
        transferTitle: 'Transfers on request',
        transferText: 'Airport pick-up and return transfers can be arranged in advance for an additional charge.',
        location: 'Address and parking',
        locationText: 'The residence is in Sveti Stefan, with private on-site parking available for guests.',
        map: 'Open map',
      };

  return (
    <section className="page-shell contact-page">
      <div className="contact-page__copy">
        <span className="eyebrow">AMR · {t('navigation.contact')}</span>
        <h1>{copy.title}</h1>
        <p>{copy.lead}</p>
        <Link className="button" to="/book">{t('common.book')}</Link>

      </div>

      <div className="contact-page__panels">
        <div className="contact-page__address">
          <span className="eyebrow">{copy.location}</span>
          <h2>{site.location}</h2>
          <p>{copy.locationText}</p>
          <a className="text-link" href={site.mapUrl} target="_blank" rel="noreferrer">{copy.map} <span>↗</span></a>
        </div>
        <div className="contact-page__transfer">
          <span className="eyebrow">AMR · Transfer</span>
          <h2>{copy.transferTitle}</h2>
          <p>{copy.transferText}</p>
        </div>
      </div>
    </section>
  );
}

export default ContactPage;
